/**
 * /devhub/remote-db — Remote database (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubRemoteSqlitePanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubRemoteSqlitePanel } from '../features/control-plane/DevHubRemoteSqlitePanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/remote-db')({ component: RemoteDbPage });

function RemoteDbPage() {
  return (
    <DevHubPanelPage
      title="Remote database"
      subtitle="Remote SQLite / local dev database projection."
      status={{ label: 'live', live: true }}
    >
      <DevHubRemoteSqlitePanel />
    </DevHubPanelPage>
  );
}
